/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const { CompoundRequestCommand } = require('./RequestCommands');

// ONLY SUPPORT ADDING FOLLOWING COMMANDS
const ALLOWED_COMMANDS = [
	'command.server.MarkCellValuesCommand',
	'command.server.SetCellsCommand'
];

class ZoomChartCommand extends CompoundRequestCommand {

	constructor() {
		super();
		// no undo/redo for zooming charts => done via button/mouse...
		this.isVolatile = true;
	}

	isRequestCommand(cmd) {
		return super.isRequestCommand(cmd) && ALLOWED_COMMANDS.includes(cmd.name);
	}
}

module.exports = ZoomChartCommand;
